import UsuarioContainer from './views/UsuarioPage';
export default UsuarioContainer;

export { default as UsuarioManager } from './usuarioManager';
